import UserInfo from '@/models/UserInfo';
import Service from '@/models/Service';
import NotificationMessage from '@/models/NotificationMessage';
import Settings from '@/config/Settings';
import { defineStore } from 'pinia';
import { useLocalStorage } from '@vueuse/core';

export const usePortalStateStore = defineStore('portalStateStore', {
  state: () => {
    return {
      form: '',
      notificationMessages: new Array<NotificationMessage>()
    };
  },
  actions: {
    cleanMessages() {
      const toDelete = new Array<string>();
      const timestamp: number = Date.now();
      for (const notificationMessage of this.notificationMessages) {
        if (!notificationMessage.persist && notificationMessage.created < timestamp - Settings.messageShowDuration) {
          toDelete.push(notificationMessage.uuid);
        }
      }
      this.notificationMessages = this.notificationMessages.filter((item) => !toDelete.includes(item.uuid));
    }
  }
});

export const useUserStore = defineStore('userStore', {
  state: () => {
    return {
      userInfo: new UserInfo(),
      services: new Array<Service>()
    };
  }
});

export const useTokenStore = defineStore('tokenStore', {
  state: () => {
    return {
      accessToken: useLocalStorage('accessToken', ''),
      idToken: useLocalStorage('idToken', '')
    };
  }
});
